/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsShoppableImage = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsShoppableImage = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $productsEl = $section.find('[data-shop-the-look-slider]');

    const $slider = $productsEl.flickity({
      accessibility: false,
      adaptiveHeight: true,
      prevNextButtons: false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      setGallerySize: true,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition === 'fade',
      on: {
        ready: function () {
          window.PXUTheme.jsShoppableImage.onFocusHandler($section, 0);
        },
        change: function (index) {
          window.PXUTheme.jsShoppableImage.onFocusHandler($section, index);
        }
      }
    });

    // Resize flickity when the slider is settled
    $productsEl.on( 'settle.flickity', function() {
      $productsEl.flickity('resize');
    })

    const $blocks = $section.find('.lookbook [data-block-index]');
    $blocks.each(function () {
      var $block = $(this);

      $block.on('mouseenter', function(event) {
        const index = parseInt(event.target.dataset.blockIndex);
        $productsEl.flickity('select', index);
      })});
  },
  onFocusHandler: function($section, index) {
    const $blocks = $section.find('.lookbook [data-block-index]');

    $blocks.each(function () {
      var $block = $(this);
      $block.removeClass('focus');
      const blockIndex = parseInt($block.data('block-index'));
    
      $block.toggleClass('focus', blockIndex === index);
    });
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-shop-the-look-slider]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex);
  },
  unload: function($section) {

  }
}

/******/ })()
;